import React, { useEffect } from "react";

// components

import CardWishlist from "../Cards/CardWishlist";
import AdminNavbar from "../Navbars/AdminNavbar.js";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbars/Navbar";
import UserSidebar from "../Sidebar/UserSidebar";
import Footer from "../Footers/Footer";

export default function Wishlist() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>

      <Navbar />
      <div className="flex relative  bg-white">

      <div className="hidden md:flex md:w-1/5">
          <UserSidebar title="Purchase List" />
        </div>

        <div className="md:w-4/5 w-full md:px-10 ">
        <CardWishlist cart={undefined} />
        </div>
      
        
       
      </div>
      <div className="absolute bottom-0 lg:block hidden">
      {/* <Footer/> */}

      </div>




    </>
  );
}
